<div id="wrap" class="practiceList-bgblue">
  <div class="common-back-btn-sight"  id="closeBtn"  (click)="close();" *ngIf="isOpenClass==0 && type!== 'huatek' && !isTencent">
    <span>×</span>
  </div>

  <div id="head_wrap" class="fontSize18">
    情景模拟
  </div>

  <!-- 提醒 -->
  <app-com-tip *ngIf="isShowToast" [type]="'toast'" [desText]="promptText" [cancelText]="''" [sureText]="''" ></app-com-tip>

  <div *ngIf="practiceList">
    <div class="practiceList-listeImgItem" [ngStyle]="{'background-image': practice.extends ? practice.extends.bg : '' }" *ngFor="let practice of practiceList;let i = index" (click)="goToNextStep(practice)">
			<div class="practiceList-listeImgItemHead-Img">

				<img *ngIf="practice.extends && practice.extends.userPhoto != ''" src="{{practice.extends.userPhoto}}" class="practiceList-icon"  />
				<div *ngIf="practice.status == 2" class="practice-status">
					已完成
				</div>
        <div *ngIf="practice.momentsList.length > 0" class="momentImg" (click)="momentView(practice.momentsList,$event)">
          <img [src]="'assets/picture/casepracticets/moment/' + practice.momentsList[0] + '.png'"  />
<!--          <img src="{{practice.momentsList[0]}}.png" alt="" />-->
        </div>
			</div>
			<div class="practiceList-listeImgItemHead fontSize16">
				{{practice.title}}
			</div>
			<div class="practiceList-listeImgItemContent fontSize14 lineHeight21">
				{{practice.description}}
				<div class="entryBtn">进入</div>
			</div>
		</div>

    <div class="approachModuleWrap" [ngClass]="type === 'huatek'? 'active':'' " *ngIf="!isCustomLock&&isShowApproach&&showGoToSurveyBtn&&isOpenClass==0&&isShowQuestionnaire&& !isTencent">
      <component-approach [theme]="approachTheme" [isFirst]="isShowQuestionnaire" (onGoCourse)="goToPostSurvey()"></component-approach>
    </div>

    <div class="approachModuleWrap" [ngClass]="type === 'huatek'? 'active':'' " *ngIf="!isCustomLock&&isShowApproach&&showGoToSurveyBtn&&isOpenClass==0&&!isShowQuestionnaire&& !isTencent">
      <component-approach [theme]="approachTheme" [isFirst]="isShowQuestionnaire" (onGoCourse)="goToPostSurvey()"></component-approach>
    </div>
  </div>

</div>

<component-momentview-pro *ngIf="showMoment" [momentList]="momentList" (onExit)="momentExit()"></component-momentview-pro>
<app-questionnaire [enter]="1" [learningPathMetaId]="learningPathMetaId" [isShowQuestionnaire]="isShowQuestionnaire && !type" (onExit)="closeQuestionnaire()"></app-questionnaire>



// WEBPACK FOOTER //
// ./src/app/case-practice-ts-list/case-practice-ts-list.component.html